import { collectionGroup, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase";

const LandingPage = () => {
  const navigate = useNavigate();
  const [totalSets, setTotalSets] = useState(0);

  useEffect(() => {
    const fetchTotalSets = async () => {
      const snapshot = await getDocs(collectionGroup(db, "workouts"));

      let setCount = 0;
      snapshot.forEach((doc) => {
        const data = doc.data();
        const exercises = data.exercises || [];

        exercises.forEach((exercise: any) => {
          const sets = exercise.sets || [];
          setCount += sets.length;
        });
      });

      setTotalSets(setCount);
    };

    fetchTotalSets();
  }, []);

  const handleLoginRedirect = () => {
    navigate("/login-spend");
  };

  return (
    <main style={{ fontFamily: "sans-serif" }}>
      {/* Header */}
      <section
        style={{
          padding: "4rem 1rem",
          textAlign: "center",
          color: "black",
        }}
      >
        <h1
          style={{
            fontSize: "2.75rem",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}
        >
          Track your workouts for free
        </h1>
        <p style={{ fontSize: "1.125rem", marginBottom: "2rem" }}>
          No download required. Just sign in and get started.
        </p>
        <button onClick={handleLoginRedirect} style={styles.primaryButton}>
          Go to Workout Tracker
        </button>
      </section>

      {/* Total Sets */}
      <section
        style={{
          padding: "4rem 1rem",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "2.25rem",
            fontWeight: "bold",
            marginBottom: "0.5rem",
          }}
        >
          {totalSets.toLocaleString()} Sets Tracked
        </h2>
        <p style={{ fontSize: "1rem", color: "#4b5563" }}>
          Join other lifters staying consistent every week.
        </p>
      </section>
    </main>
  );
};

const styles: Record<string, React.CSSProperties> = {
  primaryButton: {
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    backgroundColor: "#22c55e",
    color: "#fff",
    border: "none",
    borderRadius: "9999px",
    cursor: "pointer",
  },
  promoGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "2rem",
    width: "100%",
    maxWidth: "1000px",
  },
  promoHalf: {
    flex: "1 1 300px",
    minWidth: "300px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
};

export default LandingPage;
